module.exports = __webpack_public_path__ + "static/media/man.66899179.svg";